import { errorFromResponse } from "./errors.js";
import { clearClientRolePreview } from "../utils/demoRolePreview.js";

let statusPromise;
let version = null;
let installed = false;
let refreshing = false;

function acceptRecovery(res) {
  const confirmed = res.headers.get("X-Dev-Act-Version");
  if (res.headers.get("X-Dev-Act-Recovery") !== "expired" || !confirmed || confirmed === version) return;
  version = confirmed;
  statusPromise = undefined;
  clearClientRolePreview();
  reloadDevIdentity();
}

export async function getDevActAsStatus() {
  if (!statusPromise) statusPromise = fetch("/api/dev-act-as", { credentials: "include" }).then(async res => {
    if (res.status === 404) return { enabled: false };
    if (!res.ok) throw await errorFromResponse(res);
    const state = await res.json();
    if (state.enabled) {
      acceptRecovery(res);
      version = state.version;
      installDevIdentityFetch();
    }
    return state;
  });
  return statusPromise;
}

function installDevIdentityFetch() {
  if (installed) return;
  installed = true;
  const original = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const url = new URL(typeof input === "string" || input instanceof URL ? String(input) : input.url, window.location.href);
    if (url.origin !== window.location.origin || !url.pathname.startsWith("/api/")) return original(input, init);
    const headers = new Headers(input instanceof Request ? input.headers : undefined);
    new Headers(init.headers).forEach((v, k) => headers.set(k, v));
    // Preserve an explicitly captured version, including queued mutations.
    if (!headers.has("X-Dev-Act-Version")) headers.set("X-Dev-Act-Version", version);
    return original(input, { ...init, headers }).then(res => {
      acceptRecovery(res);
      return res; // Never retry a write under a different identity.
    });
  };
}

export async function changeDevActAs(personId) {
  const state = await getDevActAsStatus();
  if (!state.enabled) throw new Error("DEV acting-as is unavailable.");
  const res = await fetch("/api/dev-act-as/target", { method: personId ? "POST" : "DELETE",
    credentials: "include", headers: { "Content-Type": "application/json", "X-Dev-Act-Version": version },
    body: JSON.stringify(personId ? { personId } : {}) });
  if (!res.ok) throw await errorFromResponse(res);
  const changed = await res.json();
  version = changed.version;
  statusPromise = Promise.resolve(changed);
  clearClientRolePreview();
  return changed;
}

export function reloadDevIdentity() {
  // Remount every user-scoped capability/query cache, not just the auth label.
  if (refreshing) return;
  refreshing = true;
  window.location.reload();
}
